import { render } from "./payroll-additions.vue?vue&type=template&id=dd3d1ca2"
import script from "./payroll-additions.vue?vue&type=script&lang=js"
export * from "./payroll-additions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__